const state={
	Cart:'223333',
	httpUrl:'https://admin.naipu.cloud/api/', // https://api.naipu.cloud/ http://zhongnan.local
	imaUrl:'https://api.naipu.cloud/' //https://liner.440.red/
}

export default state
